
import React from 'react';
import { createRoot } from 'react-dom/client';
// i18n initialized via I18nextProvider in App
import App from './App';
import './index.css'
import { initializeGlobalScripts } from './utils/global-scripts'
import { initPerformanceOptimizations } from './utils/performanceOptimizer'
import { supabase } from '@/integrations/supabase/client';

// Initialize performance optimizations immediately
initPerformanceOptimizations();

// Initialize global scripts after DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  initializeGlobalScripts();
});

// Make supabase available for debugging
(window as any).supabase = supabase;

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element not found");
}

// Add global error handler for unhandled errors
window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);
  // Don't prevent default to allow error reporting
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  // Log Supabase 403 errors specifically
  if (event.reason?.code === 403) {
    console.error('Supabase 403 error details:', event.reason);
  }
});

createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);